import styled, { css } from 'styled-components'

/**
 * Styles-only module — MUST NOT import any component code.
 *
 * `GlobalStyles` (src/App/global.styles.ts) needs this one css constant. When
 * it lived inside NavigationMenu/index.tsx, importing it dragged the whole
 * navigation-menu graph (menu items, hooks, routing) into the login entry
 * chunk. Keeping it here lets that graph load with the app shell instead.
 */

// Sidebar column layout. The container is capped to the viewport (minus the
// header), and the menu region scrolls WITHIN itself. PRO-543: `overflow-y:
// auto` is explicit so a menu taller than the
// viewport scrolls inside the (now viewport-pinned) sider instead of dragging
// the page — previously this relied on the overflow-x:hidden ⇒ overflow-y:auto
// computed-value quirk. Kept here (styles-only) so the sticky-sider test can
// import them without the navigation-menu graph.
export const SidebarContainer = styled.div`
  height: calc(100vh - 57px); // -57px for the app header
  display: flex;
  flex-direction: column;
`

export const SidebarMenuWrapper = styled.div`
  flex: 1 1 auto;
  overflow-x: hidden;
  overflow-y: auto;
`
// DO NOT TOUCH - This style is used globally across the application
export const SubMenuStyle = css`
  .ant-menu-submenu-inline,
  .ant-menu-submenu-vertical {
    padding: 0 6px;
  }
  .ant-menu-item {
    padding: 0 6px;
    margin: 0 6px !important;
    width: auto !important;
  }
  .ant-menu-inline-collapsed > .ant-menu-item {
    padding-inline: calc(50% - 16px);
  }
  .ant-menu-submenu-popup {
    .ant-menu {
      background-color: ${(p) => p.theme.gray200} !important;
      padding: 6px 0 !important;
    }
  }
  .ant-menu-submenu-selected > .ant-menu-submenu-title {
    background-color: ${(p) => p.theme.blue200} !important;
    color: ${(p) => p.theme.navy900} !important;
  }
`
